import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "App-Startup-Acc" }
const _hoisted_2 = {
  "m-tb-0": "",
  "f-w-700": ""
}
const _hoisted_3 = {
  style: {"padding-right":"4px"},
  "mute-primary": ""
}
const _hoisted_4 = {
  style: {"padding-right":"4px"},
  "mute-primary": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _directive_blur = _resolveDirective("blur")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_avatar, {
      size: 40,
      src: _ctx.avatar
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("span", null, [
          _createTextVNode(_toDisplayString(_ctx.$filters.initials(_ctx.names)), 1)
        ])), [
          [_directive_blur, _ctx.names]
        ])
      ]),
      _: 1
    }, 8, ["src"]),
    _createElementVNode("div", null, [
      _createElementVNode("h4", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(_ctx.names), 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.headline), 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(_ctx.education.length) + " education record(s), ", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.skills.length) + " skills.", 1)
        ])
      ])
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "App-Startup-Acc-Act" }, null, -1))
  ]))
}